module.exports = __webpack_public_path__ + "static/media/internal_env_3_product_image_1.e4a2373f.webp";